<template>
  <vs-popup class="customer-bespoke-price-modeling-popup"
            title="MODEL NEW PRICING"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <template slot="actions">
 
      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="customer-bespoke-price-modeling-popup" @submit.prevent="handleSubmit(onClickUpdateBespokePrice)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_code" name="formulation_code" rules="required" v-slot="{ errors }">
                <small class="label">ITS PRODUCT CODE</small>
                <vs-input disabled v-model="createForm.formulation_code" name="formulation_code" class="w-full" label=""
                          :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row" v-if="draft_pricing_list.length > 0">
            <div class="vx-col w-full">
              <small class="label text-warning">SELECT FROM DRAFT LIST</small>
              <v-select :clearable="false" name="draftList" placeholder=""
                        @input="selectDraftPricing"
                        :options="draft_pricing_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="vx-row">
                            <div class="vx-col w-4/5">
                              <span>Created date: {{ __dateTimeFormatterToDate(option.created_at) }}</span><br>
                              <!-- <span>Tier count: {{ option.tiers.length }}</span><br> -->
                              <span class="text-break">Notes: {{ option.note || 'N/A' }}</span><br>
                              <!-- <span>Incoterm: {{ option.incoterm }}</span><br> -->
                              <!-- <span>Shipping Cost: {{ Number(option.shipping_cost).toFixed(2) }}</span> -->
                            </div>
                            <div class="vx-col w-1/5">
                              <vs-button 
                                size="small" 
                                icon-pack="feather" 
                                icon="icon-x" 
                                color="danger" 
                                class="mt-4"
                                @click.stop="onClickDeleteDraftPriceConfirm(option.id)">
                              </vs-button>
                            </div>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <span>Created date: {{ __dateTimeFormatterToDate(option.created_at) }}</span>
                          <span class="ml-2">Tier count: {{ option.tiers.length }}</span>
                        </template>
              </v-select>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full text-center">
              <vs-alert :color="createForm.using_default_pricing ? 'warning' : 'primary'" class="h-auto font-bold">
                {{ createForm.using_default_pricing ? "M&F Pricing - This product uses standard costings" : "M&F Pricing - This product uses actual costings" }}
              </vs-alert>
            </div>
          </div>

          <vx-card no-shadow title="Price Tiers">
          <vs-list>
            <draggable :list="createForm.tiers">
            <transition-group>
            <vs-list-item class="p-1 mb-4 w-full" v-for="(prices_tier, index) in createForm.tiers" :key="index+'1'">
                <div class="w-full">
                  <div v-if="checkGapBetweenTiers(index)" class="w-full mb-3">
                    <vx-card cardBorder class="w-full">
                      <div class="vx-row items-center">
                        <div class="vx-col w-4/5 text-warning font-bold">
                          There is a gap between {{ index === 0 ? 1 : createForm.tiers[index - 1].to }} - {{ createForm.tiers[index].from }} KG. Click the button to fix it.
                        </div>
                        <div class="vx-col w-1/5 text-right">
                          <vs-button @click.stop="onClickFillGaps(index)" size="small" color="warning">+ Add</vs-button>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                  <table class="w-full">
                    <tbody>
                    <tr>
                      <td style="width: 25%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <ValidationProvider :vid="index+'from'" :name="index+'from'" :rules="validate_prices_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input label-placeholder="Quantity from (Kg)"  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full"
                                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                      val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <ValidationProvider :vid="index+'to'" :name="index+'to'" :rules="validate_max_price_tier(index)"
                                              v-slot="{ errors }">
                            <vs-input label-placeholder="Quantity to (Kg)"  v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full" :danger="!!errors[0]"
                                      :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider>
                        </div>
                      </td>
                      <td style="width: 25%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input :label-placeholder="`Guide price from (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(createForm.pe_g, prices_tier.from, createForm.fx_rate, is_shipping_cost_enable)" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input :label-placeholder="`Guide price to (${account_currency}/KG)`"
                                    readonly :value="calculateProductListPrice(createForm.pe_g, prices_tier.to, createForm.fx_rate, is_shipping_cost_enable)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <td style="width: 22%;">
                        <ValidationProvider :vid="index+'price'" :name="index+'price'" rules="required" v-slot="{ errors }">
                          <vs-input :label-placeholder="`Bespoke price (${account_currency}/KG)`" v-model="prices_tier.price" type="text" name="price" class="w-full" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </td>
                      <td style="width: 20%;">
                        <div class="vx-row px-4 mb-4 mr-2">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(createForm.pe_g, prices_tier.from, prices_tier.price, is_shipping_cost_enable, createForm.fx_rate)" type="text" name="fromPrice" class="w-full"/>
                        </div>
                        <div class="vx-row px-4 mr-2 mb-4">
                          <vs-input label-placeholder=" Gross Margin % "
                                    readonly :value="calculateGrossMargin(createForm.pe_g, prices_tier.to, prices_tier.price, is_shipping_cost_enable, createForm.fx_rate)" name="toPrice" class="w-full"/>
                        </div>
                      </td>
                      <td style="width: 4%;">
                        <vs-button :disabled="createForm.tiers.length === 1" class="ml-3" @click="deletePriceTier(index)" size="small"
                                   color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                      </td>
                      <td style="width: 4%;">
                        <feather-icon icon="AlignJustifyIcon" class="cursor-pointer ml-4 mr-6 mt-1 w-8" />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </vs-list-item>
            </transition-group>
            </draggable>
          </vs-list>
          </vx-card>


          <div class="flex">
            <vs-button @click="addPriceTier" size="small" color="success" type="filled" icon-pack="feather" class="mt-4 float-left"
                     icon="icon-plus">Add prices tier
            </vs-button>
          </div>


          <div class="vx-row mb-3 mt-12">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="note" name="note" rules="required" v-slot="{ errors }">
                <small class="label">Incoterm</small>
                <v-select :append-to-body="true"
                          :clearable="true" name="incoterms" placeholder=""
                          v-model="createForm.incoterm"
                          label="code"
                          :reduce="option => option.code"
                          :options="incoterms" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2" v-if="is_shipping_cost_enable">
              <br>
              <span class="text-danger">*Please note this incoterm will add shipping to your margin calculation above and will reduce margin compared to EXW</span> 
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px"/>
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2" v-can="'make-draft-price-live'">Save as live pricing</vs-button>
            <vs-button @click="onClickSaveAsDraft()" class="ml-4 mt-2" type="border" color="warning">Save as draft</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer')
const IncotermRepository = RepositoryFactory.get('incoterm');

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Calculations from '@/mixins/Calculations'
import draggable from 'vuedraggable'

function initialState() {
  return {
    open: false,
    incoterms: [],
    createForm: {
      tiers: [],
      using_default_pricing: false, 
    },
    id: '',
    draft_pricing_list: [],
    selectedDraft: {},
    initial_create_form: null,
    selectedDraftPrice: null,
  }
}

export default {
  name: 'ModelPricingBepokePopUp',
  data() {
    return initialState()
  },
  props: {
    account_currency: {
      type: String,
      default: '',
    }
  },
  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.open = true;
        await this.fetchBespokePriceDetails()
        await this.fetchIncoterms()
        await this.fetchDraftpricingList()
        this.initial_create_form = JSON.parse(JSON.stringify(this.createForm))
      } catch (error) {

      }
    },
    hasFormChanged() {
      return JSON.stringify(this.createForm) !== JSON.stringify(this.initial_create_form);
  },
    async onClickUpdateBespokePrice() {
      if(this.selectedDraftPrice != null) {
          try {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: 'Note',
              text: "You are about to make this draft pricing live. It will be removed from the draft list. Do you want to proceed?",
              acceptText: "Proceed",
               cancelText: 'Proceed, Keep Draft',
              accept: () => { this.$emit('setBespokeLivePrice', this.createForm); this.open = false ; this.onClickDeleteDraftPrice([this.selectedDraftPrice.id])},
              cancel: () => {
                this.$emit('setBespokeLivePrice', this.createForm)
                this.open = false
              }
            })
          } catch (error) {
            this.convertAndNotifyError(error);
          }
      }
      else if(!this.hasFormChanged()) {
        try {
          this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: 'Note',
            text: "You haven't changed anything on this bespoke price. Click save will creat a duplicate record. Proceed?",
            acceptText: "Proceed",
            accept: () => { this.$emit('setBespokeLivePrice', this.createForm); this.open = false },
          })
        } catch (error) {
          this.convertAndNotifyError(error);
        }
      } else {
        this.$emit('setBespokeLivePrice', this.createForm)
        this.open = false;
      }
    },
    async fetchIncoterms() {
      try {
        const {data} = (await IncotermRepository.getListOfIncoterms(1, '', 50, '')).data
        this.incoterms = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchBespokePriceDetails() {
      await this.$vs.loading({
        container: `#customer-bespoke-price-modeling-popup`,
        scale: 0.45
      })
      const {data} = await CustomerRepository.getBespokePriceDetails(this.id)
      this.createForm = data.data
      if(this.createForm.tiers.length === 0) {
        this.createForm.tiers.push({ from: null, to: null, price: null })
      }
      this.$vs.loading.close(`#customer-bespoke-price-modeling-popup > .con-vs-loading`)
    },
    validate_prices_tier(index) {
      let previousIndex = index - 1
      return `min_than_or_equal:@${index}to|cross_over_max_equal:@${previousIndex}to|required`
    },
    validate_max_price_tier(index) {
      return `max_than_or_equal:@${index}from|required`
    },
    addPriceTier() {
      this.createForm.tiers.push(
        {from: null, to: null, price: null}
      )
    },
    deletePriceTier(index) {
      this.createForm.tiers.splice(index, 1)
    },
    async onClickSaveAsDraft() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return 
      }
      try {
        let payload =  {
          status : 'Draft'
        }
        payload.incoterm = this.createForm.incoterm
        payload.note = this.createForm.note
        payload.tiers = this.createForm.tiers.map((n) => {
          return { from : n.from, to: n.to, price: Number(n.price).toFixed(2) }
        })
        payload.shipping_cost = this.is_shipping_cost_enable ?  Number(this.createForm.pe_g.rseq5).toFixed(2) : '0.00'
        payload.customer_id = this.createForm.customer_id
        payload.formulation_id = this.createForm.formulation_id
        payload.type = 'bespoke-price'
        await CustomerRepository.addCustomerDraftBespokePrice(payload)
        this.$emit('fetchDraftpricingList')
        this.open = false;
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async fetchDraftpricingList() {
      try {
        const {data} = (await CustomerRepository.getDraftBespokePriceList(150, this.createForm.customer_id, this.createForm.formulation_id)).data
        this.draft_pricing_list = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    selectDraftPricing(data) {
      this.selectedDraftPrice = data
      this.createForm.incoterm = data.incoterm
      this.createForm.tiers = data.tiers
      this.createForm.note = data.note
      this.createForm.shipping_cost = data.shipping_cost
    },
    async onClickDeleteDraftPriceConfirm(id) {
      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          text: 'Do you want to permanently delete this item? This operation is irreversible.',
          accept: this.onClickDeleteDraftPrice,
          acceptText: 'Confirm',
          parameters: [id]
      })
    },
    async onClickDeleteDraftPrice(params) {
      try {
        this.$vs.loading({
          container: `#customer-bespoke-price-modeling-popup`,
          scale: 0.45
        })
        await CustomerRepository.removeCustomerDraftBespokePrice(params[0])
        await this.fetchDraftpricingList()
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close(`#customer-bespoke-price-modeling-popup > .con-vs-loading`)
      }
    },
    checkGapBetweenTiers(index) {
      if(index === 0) {
        const fromVal = Number(this.createForm.tiers[index].from)
        return fromVal !== 1 && fromVal !== 0
      }
      if(!this.createForm.tiers[index - 1].to || !this.createForm.tiers[index].from) {
        return false
      }
      return Number(this.createForm.tiers[index - 1].to) !== Number(this.createForm.tiers[index].from)
    },
    onClickFillGaps(index) {
      let from = index === 0 ? 1 :  Number(this.createForm.tiers[index - 1].to)
      let to = Number(this.createForm.tiers[index].from)
      this.createForm.tiers.splice(index, 0, { from: from + '', to: to + '', price: null })
    }
  },
  async mounted() {

  },
  computed: {
    is_shipping_cost_enable() {
      const find = this.incoterms.find((x) => this.createForm.incoterm === x.code)
      return find ? find.is_price_included : false
    }
  },
  components: {
    'v-select': vSelect,
    draggable,
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
.stripped-table:nth-child(even) {
  background-color: #f1f8ff;
}
.customer-bespoke-price-modeling-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 40% !important;
}

.customer-bespoke-price-modeling-popup >>> .vs-list--item {
  display: block !important;
  width: 100% !important;
  padding: 0 !important;
}

.customer-bespoke-price-modeling-popup >>> .vs-list--slot {
  margin-left: 0 !important;
  width: 100% !important;
}

</style>
